module.exports = __webpack_public_path__ + "img/product_106.1fd1de5.webp";